import { baseApi } from 'app/baseApi';
import { baseQuery } from 'app/baseQuery';
import { apiTags } from 'app/store/apiTags';

const apiPrefix = 'customReport';
export const customReportApi = baseApi.injectEndpoints({
    reducerPath: 'customReportApi',
    tagTypes: [apiTags.CUSTOM_REPORT],
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getReportByTypeForClient: builder.query({
            query: ({ formType, clientId, activityItemId }) => `${apiPrefix}/getByType?formType=${formType}&${clientId ? `clientId=${clientId}` : ''}&${activityItemId ? `activityItemId=${activityItemId}` : ''}`,
            providesTags: [apiTags.CUSTOM_REPORT],
        }),
        createReport: builder.mutation({
            query: ({ id, formId, title, description, clientId, formType, sections, activityItemId }) => ({
                url: `${apiPrefix}`,
                method: "POST",
                body: {
                    id,
                    formId,
                    title,
                    description,
                    clientId,
                    formType,
                    sections,
                    activityItemId
                }
            }),
            invalidatesTags: [apiTags.CUSTOM_REPORT]
        }),
    }),
});

export const {
    useGetReportByTypeForClientQuery,
    useCreateReportMutation
} = customReportApi;
